
export interface RefundResponse {
  amount?: number;
  message?: string;
  refundId?: string;
  status?: string;
  success: boolean;
}
